import { Animated, View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useEffect, useState } from "react";

/** Crossfades in the existing header lane without taking space from the review grid. */
export function LearnSummaryScrollTitle({
  dueReviewLabel = "Review",
  showDueCount,
}: {
  dueReviewLabel: string | null;
  showDueCount: boolean;
}) {
  const [progress] = useState(() => new Animated.Value(showDueCount ? 1 : 0));
  useEffect(() => {
    const animation = Animated.timing(progress, {
      duration: 180,
      isInteraction: false,
      toValue: showDueCount ? 1 : 0,
      useNativeDriver: true,
    });
    animation.start();
    return () => animation.stop();
  }, [progress, showDueCount]);

  return (
    <View
      accessibilityLabel={showDueCount ? (dueReviewLabel ?? "Review") : "Review"}
      accessibilityRole="header"
      accessible
      className="max-w-full items-center justify-center"
    >
      <Animated.View
        accessibilityElementsHidden
        className="absolute max-w-full"
        importantForAccessibility="no-hide-descendants"
        style={{ opacity: progress.interpolate({ inputRange: [0, 1], outputRange: [1, 0] }) }}
      >
        <Text className="text-center text-xl leading-tight font-bold">Review</Text>
      </Animated.View>
      <Animated.View
        accessibilityElementsHidden
        className="max-w-full"
        importantForAccessibility="no-hide-descendants"
        style={{ opacity: progress }}
      >
        <Text
          adjustsFontSizeToFit
          className="text-center text-xl leading-tight font-bold"
          minimumFontScale={0.6}
          numberOfLines={1}
        >
          {dueReviewLabel ?? "Review"}
        </Text>
      </Animated.View>
    </View>
  );
}
